module.exports = "/static/assets/2946d5a288356584985cf180be715a9a.png";